import {
  ArtistGenreUnionType,
  ArtistType,
  mapOrganizationUnitType,
  PermissionNameUnionType,
  useFindAllOrganizationUnitsSuspense,
} from '@api';
import { ArtistFormFields } from '@common';
import { usePermissionContext } from '@hypeit-gmbh/hypeit-ui-core';
import { FormProvider } from 'react-hook-form';
import { useEditArtistForm, useSubmitUpdateArtist } from './hooks';

type EditArtistFormPropsType = {
  artist: ArtistType;
  artistId: string;
  artistGenres: ArtistGenreUnionType[];
  onClose: () => void;
};

export const EditArtistForm: React.FC<EditArtistFormPropsType> = ({
  artist,
  artistId,
  artistGenres,
  onClose,
}) => {
  const form = useEditArtistForm(artist);
  const { data: organizationUnits } = useFindAllOrganizationUnitsSuspense({
    query: {
      select: (data) => data.data.map(mapOrganizationUnitType),
    },
  });
  const { submitUpdateArtist } = useSubmitUpdateArtist(artistId);
  const { hasPermission } = usePermissionContext<PermissionNameUnionType>();

  const userCanEditOrganizationUnit = hasPermission({
    permission: 'ORGANIZATION_UNIT',
    action: 'WRITE',
  });

  const userCanEditAbbreviation = hasPermission({
    permission: 'ARTISTS_ABBREVIATION',
    action: 'WRITE',
  });

  const handleSubmit = async (
    data: Parameters<typeof submitUpdateArtist>[0]
  ) => {
    await submitUpdateArtist(data);
    onClose();
  };

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(handleSubmit)}>
        <ArtistFormFields
          artistGenres={artistGenres}
          organizationUnits={organizationUnits}
          canEditOrganizationUnit={userCanEditOrganizationUnit}
          canEditAbbreviation={userCanEditAbbreviation}
          onClose={onClose}
        />
      </form>
    </FormProvider>
  );
};
